import { styled } from '@mui/material/styles';

import Box from "@mui/material/Box";
import { Typography } from '@mui/material';

const Title = (props) => <Typography variant="h1" {...props} />

export const DrawerTitle = styled(Title)(
    ({ theme }) => ({
        paddingRight: theme.spacing(1),
        color: theme.palette.settingsDrawer.color
    })
);

const DrawerHeader = styled(Box)(
    ({ theme, padding: p = false, display = 'flex' }) => ({
        ...theme.mixins.toolbar,
        display: display,
        justifyContent: 'space-between',
        padding: theme.spacing(p?4:0, p?3:0, 2, p?3:0),
        minHeight: 'unset !important',
    })
);

export default DrawerHeader;
